import { render, staticRenderFns } from "./New_detail.vue?vue&type=template&id=40388f73&scoped=true&"
import script from "./New_detail.vue?vue&type=script&lang=js&"
export * from "./New_detail.vue?vue&type=script&lang=js&"
import style0 from "./New_detail.vue?vue&type=style&index=0&id=40388f73&lang=scss&scoped=true&"
import style1 from "./New_detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40388f73",
  null
  
)

export default component.exports